import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import DashboardFilter from "../DashboardFilter";
import DashboardSearchInput from "../DashboardSearchInput";
import DashboardTabs from "../DashboardTabs";
import DashboardButtons from "../DashboardButtons";
import { useAmplitudeTracking } from "Services/Hooks/useAmplitudeTracking";
import { useDebouncedValue } from "Services/Hooks/useDebounce";
import { toSnakeCase } from "Services/Utils/toSnakeCase";

const DashboardFilterAndSearch = ({
  selectedTab,
  searchValue,
  selectedFilter,
  setSelectedTab,
  setSearchValue,
  setSelectedFilter,
  userIsJustAnInstaller,
}) => {
  const [showFilterMenu, setShowFilterMenu] = useState(false);

  const track = useAmplitudeTracking();

  // Debounce for tracking only - we don't want to send the value as it's PII, but check for the search values existance
  const debouncedSearchText = useDebouncedValue(searchValue, 500);

  useEffect(() => {
    const trackUserBrowisng = () => {
      track("Service User Browsing", {
        action_type: "search",
        location: "dashboard",
        filter_type: toSnakeCase(selectedFilter),
      });
    };

    if (debouncedSearchText.length >= 2) {
      trackUserBrowisng();
    }
  }, [debouncedSearchText, selectedFilter, track]);

  return (
    <div className={styles.dashboard_filter_and_search_container}>
      <div className={styles.search_input_container}>
        {selectedTab === "users" && (
          <DashboardFilter
            selectedTab={selectedTab}
            setSelectedFilter={setSelectedFilter}
            selectedFilter={selectedFilter}
            setShowFilterMenu={setShowFilterMenu}
            showFilterMenu={showFilterMenu}
            userIsJustAnInstaller={userIsJustAnInstaller}
          />
        )}
        <DashboardSearchInput
          selectedTab={selectedTab}
          value={searchValue}
          setValue={setSearchValue}
          onTrack={track}
        />
      </div>
      <div className={styles.search_tabs_and_buttons_container}>
        <DashboardTabs
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
        <DashboardButtons selectedTab={selectedTab} />
      </div>
    </div>
  );
};

export default DashboardFilterAndSearch;
